/** Expose the main function */

globalThis.sliceGeometry = require("./slice").sliceGeometry;